export default __webpack_public_path__ + "static/media/logo.5939338c.png";